module.exports = __webpack_public_path__ + "static/media/sent-payments-icon.629f6949.svg";